module.exports = "<headerMenu></headerMenu>\r\n<br />\r\n<div class=\"about_content\">\r\n<iframe style=\"border-style: none;width: 100%; height: 500px\" [src]=\"pageurl | safe\"></iframe></div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/sharedcomponents/icecommonpages/icecommonpages.component.html
// module id = ./src/app/sharedcomponents/icecommonpages/icecommonpages.component.html
// module chunks = main